<template>
  <footer id="footer">
    <div class="container">
      <ul class="footer-address bx-shadow">
        <li
          :style="{display: 'inline', width: '100%'}"
          class="text-center"
        >
          <a href="mailto:kontakt@elsazeit.de">kontakt@elsazeit.de</a>
        </li>
      </ul>
      <div class="footer-frame">
        <div class="logo-frame">
          <div class="logo">
            <a href="#"><img
              src="@/../public/img/logo.png"
              alt="elsa zeit"
              width="239"
              height="53"></a>
          </div>
          <div class="powered-by">
            <span class="text-bold">powered by KI –</span><br>künstliche Intelligenz.
          </div>
        </div>
        <ul class="footer-links">
          <li><a href="/impressum">Impressum</a></li>
          <li><a href="/datenschutz">Datenschutz</a></li>
          <li>
            <a
              href="/content/2019-04-02-elsazeit-agb.pdf"
              download
            >
              AGB
            </a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'HomeFooter'
}
</script>

<style scoped>

</style>
